import DOMPurify from 'dompurify'

export { sanitizeCardDescription } from '@/shared/utils/sanitize'

const RICH_TEXT_ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'p', 'br']

export const escapeHtml = (text) => {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
  }
  return text.replace(/[&<>"']/g, (char) => map[char])
}

export const sanitizeRichText = (html) => {
  if (html == null) {
    return ''
  }
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS: RICH_TEXT_ALLOWED_TAGS,
    ALLOWED_ATTR: []
  })
}

export const sanitizeSvg = (svg) => {
  if (svg == null) {
    return ''
  }
  return DOMPurify.sanitize(String(svg), {
    USE_PROFILES: { svg: true, svgFilters: true, html: true },
    ADD_TAGS: ['foreignObject'],
    HTML_INTEGRATION_POINTS: { 'annotation-xml': true, foreignobject: true }
  })
}

export const stripHtml = (html) => {
  if (!html) return ''
  const temp = document.createElement('div')
  temp.innerHTML = html
  return temp.textContent || temp.innerText || ''
}

export const htmlToText = (html) => {
  if (!html) {
    return ''
  }
  const withSeparators = String(html)
    .replace(/<\/(p|div|li|h[1-6]|tr)>/gi, ' ')
    .replace(/<br\s*\/?>/gi, ' ')

  return stripHtml(withSeparators).replace(/\s+/g, ' ').trim()
}

export const sanitizeFilename = (name, extension) => {
  return (name || 'export')
    .toLowerCase()
    .replace(/[\s/\\:*?"<>|]+/g, '-')
    .replace(/^-+|-+$/g, '') + '.' + extension
}
